export enum CmsInformationConstants {
  NOT_IMPLEMENTED = 'cmsInformation/NOT_IMPLEMENTED',
  SET_CMSCONDITIONCODE = 'cmsInformation/SET_CMSCONDITIONCODE',
  SET_CONDITIONCODEMODIFIER = 'cmsInformation/SET_CONDITIONCODEMODIFIER',
  SET_CMSTRANSPORTREASON = 'cmsInformation/SET_CMSTRANSPORTREASON',
  SET_AMBULANCECONDITIONINDICATION = 'cmsInformation/SET_AMBULANCECONDITIONINDICATION',
  SET_CMSINFORMATION = 'cmsInformation/SET_CMSINFORMATION',
  SET_RESPONSE = 'cmsInformation/SET_RESPONSE',
  CMSINFORMATION_ACTION_SAVE = 'cmsInformation/CMSINFORMATION_ACTION_SAVE',
  RESET_STATE = 'cmsInformation/RESET_STATE',
  SET_CMS_INFORMATION = 'cmsInformation/SET_CMS_INFORMATION',
}
